import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../selectors';
import UiActions from '../actions/ui';
import strings from '../strings';
import HelpModal from './Modals/HelpModal';

class Footer extends Component {
    static propTypes = { openHelpModal: PropTypes.func.isRequired };

    static mapState = (state) =>
        mapSelectors(state, {
            isLoggedIn: selectors.login.getIsLoggedIn,
        });

    static mapDispatch = (dispatch) => ({
        openHelpModal: () => dispatch(UiActions.openHelpModal()),
    });

    _renderButton() {
        if (!this.props.isLoggedIn) {
            return <span />;
        }

        return (
            <button
                className="btn btn-info-outline btn-sm help-button"
                onClick={() => this.props.openHelpModal()}
            >
                {strings.needHelpQuestion}
            </button>
        );
    }

    render() {
        return (
            <div className="container-full border-top p-y">
                <div className="item-flex">
                    <div className="item-flex-main" />
                    <div className="item-flex-addon text-xs text-muted">
                        {this._renderButton()}
                    </div>
                </div>
                <HelpModal /> {/* redux connected */}
            </div>
        );
    }
}

export default attach(Footer);



// WEBPACK FOOTER //
// ./app/components/Footer.jsx